/**
 * @architecture-header 1
 * @layer app
 * @domain parallel-development
 * @responsibility Reserve Agent A's workspace content contribution seam.
 * @state-owner Agent A feature modules
 * @allowed-imports React types; shared composition contract; Agent A module public APIs
 * @forbidden Agent B modules; routes; direct API clients
 * @public-api WorkspaceSectionContent aggregator
 * @side-effects none until an Agent A card contributes content
 * @tests WorkspaceSectionContent.test.tsx
 */

import { isValidElement, type ReactNode } from 'react';
import { ActivityBoard } from '../../../modules/activities';
import type { WorkspaceSectionContentContext } from '../types';

export function agentASectionContent(
  context: WorkspaceSectionContentContext,
  fallback: ReactNode,
): ReactNode | undefined {
  if (context.role === 'teacher' && context.section === 'act') {
    if (
      context.surface === 'desktop-main' &&
      isValidElement(fallback) &&
      fallback.type === ActivityBoard
    ) {
      return <ActivityBoard surface="desktop" />;
    }
    if (context.surface === 'mobile-list') return <ActivityBoard surface="mobile" />;
  }
  return undefined;
}
